"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const role_1 = require("services/user-access/role");
const user_role_types_1 = require("./user-role.types");
const getDataGrid = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, role_1._getRole)(dataStates);
    const responseMenu = yield (0, role_1._getMenu)(Object.assign(Object.assign({}, dataStates), { skip: 0, take: 1000 }));
    const dataMenu = responseMenu.data;
    const dataMenuFiltered = dataMenu.filter(i => i ==
        dataMenu.find(j => j.module === i.module && j.submodule === i.submodule));
    const dataMobileWeb = dataMenu.filter(i => !dataMenuFiltered.includes(i));
    if (response.isError) {
        dispatch({
            type: user_role_types_1.userRoleTypes.SET_ERROR, payload: {
                isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage
            }
        });
    }
    else {
        const payload = {
            dataMobileWeb,
            count: response.countData,
            dataGridRoleMapping: dataMenuFiltered.map(i => {
                var _a;
                return Object.assign(Object.assign({}, i), { subId: (_a = dataMobileWeb.find(x => x.module === i.module && x.submodule === i.submodule)) === null || _a === void 0 ? void 0 : _a.id });
            }),
            dataGrid: response.isError ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date), status: item.is_active ? 'Active' : 'Inactive' });
            })
        };
        dispatch({ type: user_role_types_1.userRoleTypes.SET_DATA_GRID, payload });
    }
});
const onDataStateChange = (dataStates) => dispatch => {
    const payload = {
        dataStates
    };
    dispatch({ type: user_role_types_1.userRoleTypes.ON_PAGE_CHANGE, payload });
};
const onFilterChange = payload => dispatch => {
    dispatch({ type: user_role_types_1.userRoleTypes.ON_FILTER_CHANGE, payload });
};
const onClickMutation = (payload) => dispatch => {
    dispatch({ type: user_role_types_1.userRoleTypes.ON_MUTATION_CLICK, payload });
};
const onDelete = payload => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, role_1._deleteRole)({ id: payload.dataItem.id });
    const isSuccess = !response.isError;
    if (isSuccess)
        dispatch({ type: user_role_types_1.userRoleTypes.ON_DELETE, payload: Object.assign(Object.assign({}, payload), { isSuccess }) });
    else
        dispatch({
            type: user_role_types_1.userRoleTypes.SET_ERROR, payload: Object.assign(Object.assign({}, payload), { isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage })
        });
});
const closeError = () => dispatch => {
    dispatch({
        type: user_role_types_1.userRoleTypes.SET_ERROR,
        payload: {
            errorCode: 0,
            errorMessage: '',
            isError: false
        }
    });
};
const onSaveDataItem = payload => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const { mutationMode } = payload;
    const response = payload.mutationMode == 'add' ?
        yield (0, role_1._createRole)({
            name: payload.dataItem.name,
            is_active: payload.dataItem.is_active,
            modified_by: payload.dataItem.modified_by
        }) :
        yield (0, role_1._editRole)({
            id: payload.dataItem.id,
            name: payload.dataItem.name,
            is_active: payload.dataItem.is_active,
            authorization: payload.dataItem.authorization.length > 0 ? payload.dataItem.authorization : [],
            modified_by: payload.dataItem.modified_by
        });
    const dataItem = Object.assign(Object.assign({}, payload.dataItem), { id: response.data.id });
    const isSuccess = !response.isError;
    if (isSuccess)
        dispatch({ type: user_role_types_1.userRoleTypes.ON_SAVE_DATAITEM, payload: Object.assign(Object.assign({}, payload), { dataItem, mutationMode, isSuccess }) });
    else
        dispatch({
            type: user_role_types_1.userRoleTypes.SET_ERROR, payload: Object.assign(Object.assign({}, payload), { isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage })
        });
});
const onLoading = () => dispatch => {
    dispatch({ type: user_role_types_1.userRoleTypes.SET_LOADING, payload: true });
};
exports.default = {
    onDelete,
    onLoading,
    closeError,
    getDataGrid,
    onSaveDataItem,
    onFilterChange,
    onClickMutation,
    onDataStateChange,
};
